<script setup lang="ts">
import { useRoute } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'

const route = useRoute()
</script>

<template>
  <RouterView v-if="route.meta.bare" />
  <DefaultLayout v-else>
    <RouterView />
  </DefaultLayout>
</template>
